import { calcDaysOfLife } from './../helpers/date';
import { Loan } from './../loan/loan.model';
import { PaycheckAdvance } from './../paycheck-advance';

export const GIVEUPABLE_DAYS_AFTER_PURCHASE = 8;

export enum SERVICE_STATUS {
  CNAB_PENDING = 'CNAB_PENDING',
  CREDIT_ERROR = 'CREDIT_ERROR',
  CREDIT_PENDING = 'CREDIT_PENDING',
  DEFAULT = 'DEFAULT',
  ENDORSEMENT_CREATED = 'ENDORSEMENT_CREATED',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  FINISHED = 'FINISHED',
  GAVE_UP = 'GAVE_UP',
  IN_PROGRESS = 'IN_PROGRESS',
  PIX_PROCESSING = 'PIX_PROCESSING',
  PIX_PROCESSING_ERROR = 'PIX_PROCESSING_ERROR',
  RENEGOTIATING = 'RENEGOTIATING',
  RESTRUCTURED = 'RESTRUCTURED',
}

export const SERVICE_CCB_DOWNLOADABLE_STATUSES = [
  SERVICE_STATUS.DEFAULT,
  SERVICE_STATUS.FINISHED,
  SERVICE_STATUS.GAVE_UP,
  SERVICE_STATUS.IN_PROGRESS,
];

export const SERVICE_LIQUIDATEABLE_STATUSES = [
  SERVICE_STATUS.IN_PROGRESS,
  SERVICE_STATUS.RENEGOTIATING,
];

export const SERVICE_GIVEUPABLE_STATUSES = [SERVICE_STATUS.IN_PROGRESS];

export function isServiceGiveupable(service: Loan | PaycheckAdvance): boolean {
  const insideDateLimite = calcDaysOfLife(service.created) < GIVEUPABLE_DAYS_AFTER_PURCHASE;
  const hasGiveupableStatus = SERVICE_GIVEUPABLE_STATUSES.includes(
    (service as Loan).status || (service as PaycheckAdvance).processingStatus,
  );
  return insideDateLimite && hasGiveupableStatus;
}
